import React, { PureComponent } from 'react';
import ReactSVG from 'react-svg';


import './SelectBubble.css';


class SelectBubble extends PureComponent {

	

	render() {
		return(
			<div className={"bubble-wrapper " + this.props.item.replace(/\s/g, '').toLowerCase()} >
				<div data-tip={this.props.item} 
					className={this.props.className}
					 onClick={() => this.props.handleOnClick(this.props.typeSelected)} 
				>
		            <div className="checkbox">
		                <div className="check fa fa-check"/>
		            </div>
		            <div className="multiselect-component__label">
		                <div className="multiselect-component__image-wrapper">
		                    <ReactSVG path={this.props.path} wrapperClassName="svg-wrapper" style={{ width: '82px', height: '82px' }}/>
		                </div>
		                <div className="multiselect-component__text">
		                    <div className="multiselect-component__title">{this.props.item}</div>	                   	
		                </div>
		            </div>
		        </div>
		    </div>
		    );
		 
	     
           
	    }

       

}


export default SelectBubble;



// WEBPACK FOOTER //
// ./src/components/onboarding/SelectBubble.js